import { languageQuery, isMobileQuery, ipCountryQuery, configQuery, uniqueValues, getFeatureValueV2 } from '@gig/magic-common';
import { USER_LOGGED_IN_UPDATED, GAMES_CATEGORIES_LIST, GAMES_CATEGORIES_CMS_CONTENT, LANGUAGE_UPDATED, GAMES_LOADED, DEVICE_QUERY, GAMES_LOBBIES_UPDATED, GAMES_PROVIDERS, GAMES_RECOMMENDED_GAMES, FEATURE_QUERY_ACTIVE, Feature, USER_LOGGED_IN_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator, __assign } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { openGamesDB } from './game-db.js';
import { dynamicRecommendationCategories } from './filter-category.js';

var GamesFetchService = /** @class */ (function () {
    function GamesFetchService(gamesService) {
        this.gamesService = gamesService;
        this.categories = [];
        this.lobbies = [];
        this.recommendedGames = [];
        this.subscribeToLanguageChange();
        this.subscribeToLoggedInChanges();
    }
    GamesFetchService.prototype.subscribeToLoggedInChanges = function () {
        var _this = this;
        setTimeout(function () {
            window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.computeUpdatedCategories()];
                        case 1:
                            _a.sent();
                            window.eventBus.publish(GAMES_CATEGORIES_LIST, this.categories);
                            return [2 /*return*/];
                    }
                });
            }); });
        });
    };
    GamesFetchService.prototype.subscribeToCategoriesCmsContent = function () {
        var _this = this;
        window.queryBus.subscribe(GAMES_CATEGORIES_CMS_CONTENT, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var db, category;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.getCategoryBySlug(event.payload)];
                    case 2:
                        category = _a.sent();
                        db.close();
                        return [2 /*return*/, category];
                }
            });
        }); });
    };
    GamesFetchService.prototype.subscribeToLanguageChange = function () {
        var _this = this;
        window.eventBus.subscribe(LANGUAGE_UPDATED, function () {
            return _this.fetchGames();
        }, { replay: true, distinct: true });
    };
    GamesFetchService.prototype.fetchGames = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, language, device, isMobile, country, defaultGameCategories, defaultLobby, payload;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        window.eventBus.publish(GAMES_LOADED, false);
                        return [4 /*yield*/, Promise.all([
                                languageQuery(),
                                window.queryBus.query(DEVICE_QUERY),
                                isMobileQuery(),
                                ipCountryQuery(),
                                configQuery('defaultGameCategories'),
                                configQuery('defaultLobby'),
                            ])];
                    case 1:
                        _a = _b.sent(), language = _a[0], device = _a[1], isMobile = _a[2], country = _a[3], defaultGameCategories = _a[4], defaultLobby = _a[5];
                        return [4 /*yield*/, magic.methods.games.fetch(isMobile, language, country, device, defaultGameCategories)];
                    case 2:
                        payload = _b.sent();
                        return [4 /*yield*/, this.setGamesAndCategories(payload, defaultLobby)];
                    case 3:
                        _b.sent();
                        window.eventBus.publish(GAMES_LOADED, true);
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesFetchService.prototype.setGamesAndCategories = function (payload, defaultLobby) {
        return __awaiter(this, void 0, void 0, function () {
            var games, cmsCategories, db;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        games = this.preprocessGames(payload);
                        cmsCategories = this.preprocessCategories(payload, defaultLobby);
                        this.preprocessLobbies(cmsCategories, games);
                        return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _a.sent();
                        Promise.all([db.put(games), db.putCategories(cmsCategories)]).then(function () {
                            games.clear();
                            db.close();
                        });
                        this.gamesService.updateViewGames(games);
                        return [4 /*yield*/, this.computeUpdatedCategories(cmsCategories)];
                    case 2:
                        _a.sent();
                        window.eventBus.publish(GAMES_CATEGORIES_LIST, this.categories);
                        window.eventBus.disableHistory(GAMES_CATEGORIES_LIST);
                        window.eventBus.publish(GAMES_LOBBIES_UPDATED, this.lobbies);
                        this.vendors = payload[2];
                        window.eventBus.publish(GAMES_PROVIDERS, this.vendors);
                        this.recommendedGames = payload[3];
                        window.eventBus.publish(GAMES_RECOMMENDED_GAMES, this.recommendedGames);
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesFetchService.prototype.preprocessGames = function (payload) {
        var _this = this;
        payload[0].forEach(function (game) {
            game.lobbies = [];
            game.category = _this.getValidCategory(game);
        });
        return payload[0];
    };
    GamesFetchService.prototype.preprocessCategories = function (payload, defaultLobby) {
        var categories = payload[1].map(function (cat) {
            var category = __assign({}, cat);
            if ('games' in cat) {
                category.games = cat.games || new Set();
            }
            if (!category.lobby) {
                category.lobby = defaultLobby;
            }
            return category;
        });
        var mainLobbies = categories.filter(function (c) { return c.main; });
        categories
            .filter(function (c) { return !c.main; })
            .forEach(function (c) {
            var main = mainLobbies.find(function (mainC) {
                return mainC.subCategories.has(c.slug);
            });
            if (main) {
                c.lobby = main.lobby;
            }
        });
        return categories;
    };
    GamesFetchService.prototype.addGreInformation = function (categories) {
        return __awaiter(this, void 0, void 0, function () {
            var greCategories, greCategoriesActive, greCategoriesConfigured, greSlugs_1, filtered, isLoggedIn, promises, categoriesSlugsToRemove, _loop_1, this_1, _i, categories_1, category;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        greCategories = categories.filter(function (category) {
                            return dynamicRecommendationCategories(category);
                        });
                        return [4 /*yield*/, this.isGreCategoriesActive()];
                    case 1:
                        greCategoriesActive = _a.sent();
                        return [4 /*yield*/, this.getGreCategoriesConfigured()];
                    case 2:
                        greCategoriesConfigured = _a.sent();
                        if (!greCategoriesActive) {
                            greSlugs_1 = greCategories.map(function (c) { return c.slug; });
                            filtered = categories.filter(function (category) { return !greSlugs_1.includes(category.slug); });
                            return [2 /*return*/, Promise.resolve(filtered)];
                        }
                        return [4 /*yield*/, this.isLoggedIn()];
                    case 3:
                        isLoggedIn = _a.sent();
                        promises = [];
                        categoriesSlugsToRemove = [];
                        _loop_1 = function (category) {
                            if (!dynamicRecommendationCategories(category)) {
                                return "continue";
                            }
                            var summary = category.greSettings.summary;
                            if (summary === 'Similar Game Recommendations') {
                                if (!greCategoriesConfigured.includes('game')) {
                                    categoriesSlugsToRemove.push(category.slug);
                                }
                                else {
                                    promises.push(this_1.fetchSimilarGamesRecommendations(category).then(function (similarGames) {
                                        category.games = new Set(similarGames);
                                    }));
                                }
                            }
                            if (summary === 'Market Recommendations') {
                                if (!greCategoriesConfigured.includes('market')) {
                                    categoriesSlugsToRemove.push(category.slug);
                                }
                                else {
                                    promises.push(this_1.fetchMarketRecommendations(category.slug).then(function (marketGames) {
                                        category.games = new Set(marketGames);
                                    }));
                                }
                            }
                            if (summary === 'User Recommendations') {
                                if (!isLoggedIn || !greCategoriesConfigured.includes('user')) {
                                    categoriesSlugsToRemove.push(category.slug);
                                }
                                else {
                                    promises.push(this_1.fetchUserRecommendations(category.slug).then(function (userGames) {
                                        category.games = new Set(userGames);
                                    }));
                                }
                            }
                        };
                        this_1 = this;
                        for (_i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
                            category = categories_1[_i];
                            _loop_1(category);
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/, categories.filter(function (category) { return !categoriesSlugsToRemove.includes(category.slug); })];
                }
            });
        });
    };
    GamesFetchService.prototype.preprocessLobbies = function (cmsCategories, games) {
        cmsCategories.forEach(function (cat) {
            if (!cat.games) {
                return;
            }
            cat.games.forEach(function (gameSlug) {
                var game = games.get(gameSlug);
                if (!game) {
                    return;
                }
                if (!game.lobbies) {
                    game.lobbies = [];
                }
                if (!game.lobbies.includes(cat.lobby)) {
                    game.lobbies.push(cat.lobby);
                }
            });
        });
        var uniqueLobbies = uniqueValues(cmsCategories.map(function (category) { return category.lobby; }));
        this.lobbies = uniqueLobbies.map(function (lobby) {
            var _a;
            return (_a = {},
                _a[lobby] = cmsCategories
                    .filter(function (cat) { return cat.lobby === lobby; })
                    .map(function (cat) { return cat.slug; }),
                _a);
        });
    };
    GamesFetchService.prototype.getValidCategory = function (game) {
        var category = game.category, categories = game.categories;
        if (category === 'mini-games' || category === 'free-to-play-category') {
            categories = categories.filter(function (c) { return c !== 'mini-games' && c !== 'free-to-play-category'; });
            category = categories[0] || '';
        }
        return category;
    };
    GamesFetchService.prototype.computeUpdatedCategories = function (cmsCategories) {
        return __awaiter(this, void 0, void 0, function () {
            var categories, _a, filteredCategories;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = cmsCategories;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCategoriesFromDb()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        categories = (_a).map(function (cmsCategory) {
                            var category = __assign({}, cmsCategory);
                            delete category.metaTitle;
                            delete category.metaDescription;
                            delete category.description;
                            delete category.modified;
                            delete category.compressPublish;
                            delete category.desktop;
                            delete category.mobile;
                            delete category.igcId;
                            delete category.group;
                            delete category.lang;
                            return category;
                        });
                        return [4 /*yield*/, this.addGreInformation(categories)];
                    case 3:
                        filteredCategories = _b.sent();
                        // Sort categories- prioritize those with subcategories and then by position
                        this.categories = filteredCategories.sort(function (a, b) {
                            var _a, _b;
                            var aHasSubcategories = ((_a = a.subCategories) === null || _a === void 0 ? void 0 : _a.size) > 0;
                            var bHasSubcategories = ((_b = b.subCategories) === null || _b === void 0 ? void 0 : _b.size) > 0;
                            if (aHasSubcategories && !bHasSubcategories) {
                                return -1;
                            }
                            if (!aHasSubcategories && bHasSubcategories) {
                                return 1;
                            }
                            return a.position - b.position;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    GamesFetchService.prototype.getCategoriesFromDb = function () {
        return __awaiter(this, void 0, void 0, function () {
            var db, categories;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _a.sent();
                        return [4 /*yield*/, db.getCategories()];
                    case 2:
                        categories = _a.sent();
                        db.close();
                        return [2 /*return*/, categories];
                }
            });
        });
    };
    GamesFetchService.prototype.fetchMarketRecommendations = function (categorySlug) {
        return __awaiter(this, void 0, void 0, function () {
            var userLocation, response, gameIds, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.getUserLocation()];
                    case 1:
                        userLocation = _a.sent();
                        return [4 /*yield*/, magic.methods.games.getGREMarketRecommendations({
                                category_slug: categorySlug,
                                user_location: userLocation,
                            })];
                    case 2:
                        response = _a.sent();
                        gameIds = Object.values(response.games);
                        return [2 /*return*/, this.mapGameIdsToSlugs(gameIds)];
                    case 3:
                        error_1 = _a.sent();
                        console.error('Failed to fetch market recommendations:', error_1);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesFetchService.prototype.fetchUserRecommendations = function (categorySlug) {
        return __awaiter(this, void 0, void 0, function () {
            var requestPayload, response, gameIds, e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        _a = {
                            category_slug: categorySlug
                        };
                        return [4 /*yield*/, this.getUserLocation()];
                    case 1:
                        requestPayload = (_a.user_location = _b.sent(),
                            _a);
                        return [4 /*yield*/, magic.methods.games.getDynamicUserRecommendedCategory(requestPayload)];
                    case 2:
                        response = _b.sent();
                        gameIds = Object.values(response.games);
                        return [2 /*return*/, this.mapGameIdsToSlugs(gameIds)];
                    case 3:
                        e_1 = _b.sent();
                        console.error('Failed to fetch user recommendations ', e_1);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesFetchService.prototype.fetchSimilarGamesRecommendations = function (category) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var firstGameFromCMS, firstGame, params, response, gameIds, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        if (!category) {
                            return [2 /*return*/, []];
                        }
                        firstGameFromCMS = (_a = category.games) === null || _a === void 0 ? void 0 : _a.values().next().value;
                        if (!firstGameFromCMS) {
                            return [2 /*return*/, []];
                        }
                        return [4 /*yield*/, this.queryGameBySlug(firstGameFromCMS)];
                    case 1:
                        firstGame = _b.sent();
                        if (!firstGame) {
                            return [2 /*return*/, []];
                        }
                        params = {
                            category_slug: category.slug,
                            game_id: firstGame.gameId,
                        };
                        return [4 /*yield*/, magic.methods.games.getGRESimilarGameRecommendations(params)];
                    case 2:
                        response = _b.sent();
                        if (!(response === null || response === void 0 ? void 0 : response.games)) {
                            return [2 /*return*/, []];
                        }
                        gameIds = Object.values(response.games).flat();
                        return [2 /*return*/, this.mapGameIdsToSlugs(gameIds)];
                    case 3:
                        error_2 = _b.sent();
                        console.error('Failed to fetch similar games recommendations:', error_2);
                        return [2 /*return*/, []];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesFetchService.prototype.getUserLocation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userLocation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ipCountryQuery()];
                    case 1:
                        userLocation = _a.sent();
                        return [2 /*return*/, userLocation.toLowerCase()];
                }
            });
        });
    };
    GamesFetchService.prototype.isGreCategoriesActive = function () {
        return window.queryBus.query(FEATURE_QUERY_ACTIVE, Feature.DYNAMIC_CATEGORY);
    };
    GamesFetchService.prototype.getGreCategoriesConfigured = function () {
        return __awaiter(this, void 0, void 0, function () {
            var value;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getFeatureValueV2(Feature.DYNAMIC_CATEGORY, '')];
                    case 1:
                        value = _a.sent();
                        return [2 /*return*/, (value || '').split(',')];
                }
            });
        });
    };
    GamesFetchService.prototype.isLoggedIn = function () {
        return window.queryBus.query(USER_LOGGED_IN_QUERY);
    };
    GamesFetchService.prototype.mapGameIdsToSlugs = function (gameIds) {
        return __awaiter(this, void 0, void 0, function () {
            var gameSlugs;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(gameIds.map(function (gameId) { return __awaiter(_this, void 0, void 0, function () {
                            var game;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.queryGameById(gameId)];
                                    case 1:
                                        game = _a.sent();
                                        return [2 /*return*/, game === null || game === void 0 ? void 0 : game.slug];
                                }
                            });
                        }); }))];
                    case 1:
                        gameSlugs = _a.sent();
                        return [2 /*return*/, gameSlugs.filter(Boolean)];
                }
            });
        });
    };
    GamesFetchService.prototype.queryGameById = function (gameId) {
        return __awaiter(this, void 0, void 0, function () {
            var db, game, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _b.sent();
                        return [4 /*yield*/, db.getById(gameId)];
                    case 2:
                        game = _b.sent();
                        db.close();
                        return [2 /*return*/, game];
                    case 3:
                        _a = _b.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GamesFetchService.prototype.queryGameBySlug = function (slug) {
        return __awaiter(this, void 0, void 0, function () {
            var db, game, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, openGamesDB()];
                    case 1:
                        db = _b.sent();
                        return [4 /*yield*/, db.getBySlug(slug)];
                    case 2:
                        game = _b.sent();
                        db.close();
                        return [2 /*return*/, game];
                    case 3:
                        _a = _b.sent();
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return GamesFetchService;
}());

export { GamesFetchService };
